// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56600":"13237d68","71650":"5cd24f1d","76938":"cbf74bec"}[chunkId] + ".chunk.css";
};